import { ANDROID_STORE_URL, IOS_STORE_URL } from './storeLinks';

// Accept public campaign codes only, never arbitrary URLs, health or account data.
const SOURCES = new Set(['ppomppu', 'disquiet', 'dcinside', 'ruliweb', 'geeknews',
    'androidpub', 'meeco', 'pumasi', 'clien', 'share', 'qr', 'search', 'direct']);
const MEDIUMS = new Set(['community', 'referral', 'share', 'qr', 'organic', 'owned_asset', 'none']);
const CAMPAIGN = /^(install|repeat_reminder|repeat_demo_\d{8})$/;

export function readInstallAttribution(search = '') {
    const query = new URLSearchParams(search);
    const input = name => (query.get(name) || '').toLowerCase();
    const requestedSource = input('utm_source');
    const source = SOURCES.has(requestedSource) ? requestedSource : requestedSource ? 'other' : 'direct';
    const requestedMedium = input('utm_medium');
    const medium = MEDIUMS.has(requestedMedium) ? requestedMedium : source === 'direct' ? 'none' : 'referral';
    const requestedCampaign = input('utm_campaign');
    const campaign = CAMPAIGN.test(requestedCampaign) ? requestedCampaign : 'install';
    return { source, medium, campaign };
}

export function installCampaignQuery(attribution) {
    return new URLSearchParams({ utm_source: attribution.source,
        utm_medium: attribution.medium, utm_campaign: attribution.campaign });
}

export function installStoreUrl(store, search = '') {
    const a = readInstallAttribution(search);
    if (store === 'android') {
        const url = new URL(ANDROID_STORE_URL);
        const campaign = installCampaignQuery(a);
        for (const [key, value] of campaign) url.searchParams.set(key, value);
        url.searchParams.set('referrer', campaign.toString());
        return url.href;
    }
    if (store === 'ios') {
        const url = new URL(IOS_STORE_URL);
        url.searchParams.set('pt', '126966283');
        url.searchParams.set('ct', `${a.source}_${a.campaign}`);
        url.searchParams.set('mt', '8');
        return url.href;
    }
    throw new Error('Unknown install store');
}
